import React from 'react';
import { TextVariant } from '@naf/text';
import { IMAGE_SIZES } from '@components/image/ResponsiveImage.sizes';
import { QnAItem } from '../../QnaFeedBlock/QnaList';
import { ButtonGroup, MediaComponent } from '../StyledFeaturedBenefitBlock';
import { HeadingBlock, Description } from '../Styles';
import { FeaturedBenefitBlockTypeProps } from '../FeaturedBenefitBlock/FeaturedBenefitBlock';
import * as S from './WithQnA.styles';

export const WithQnA: React.FC<FeaturedBenefitBlockTypeProps> = ({ block }) => {
  const { title, description, colorVariant, primaryCta, secondaryCta, questionsAndAnswersBlock, image } = block;
  const entries = questionsAndAnswersBlock?.qnaEntries?.filter((d) => d.publishedTime) || [];

  return (
    <S.Container>
      <S.Left>
        <S.InnerLeft>
          <S.ImageWrapper>
            <MediaComponent image={image} sizes={IMAGE_SIZES.featuredBenefitTile} />
          </S.ImageWrapper>
          <S.StyledHeading variant={TextVariant.Header1}>
            <HeadingBlock value={title} />
          </S.StyledHeading>
          <Description>{description}</Description>
          <S.ButtonWrapper>
            <ButtonGroup primaryCta={primaryCta} secondaryCta={secondaryCta} colorVariant={colorVariant} />
          </S.ButtonWrapper>
        </S.InnerLeft>
      </S.Left>
      <S.Right>
        <S.InnerRight>
          <S.QnAItemWrapper>
            <S.QnATitle variant={TextVariant.DataLabel}>{questionsAndAnswersBlock?.title}</S.QnATitle>
            <S.ScrollContainer>
              {entries.map((entry, i) => (
                <S.ScrollItem $isFirst={i === 0} $isLast={i === entries.length - 1} key={entry._key}>
                  <QnAItem entry={entry} omitTimestamp />
                </S.ScrollItem>
              ))}
            </S.ScrollContainer>
          </S.QnAItemWrapper>
        </S.InnerRight>
      </S.Right>
    </S.Container>
  );
};
